import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { disableDevToolsInProduction } from './lib/stores/secure-storage';
import { initTabTracker } from './lib/stores/tab-tracker';
import './i18n/config';
import './styles/globals.css';

// Disable devtools inspection in production
disableDevToolsInProduction();

// Clear token when the last tab of the app is closed
initTabTracker();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
